import { inputCls, btnPrimary } from "../bits";
import { Plus } from "lucide-react";

export function CircularForm({ form, setForm, fileRef, busy, onAdd }) {
  return (
    <div className="bg-surface rounded-2xl border border-brd shadow-md p-5 mb-6">
      <div className="grid sm:grid-cols-2 gap-3 mb-3">
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">عنوان التعميم *</label>
          <input data-testid="circular-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })}
            className={inputCls} placeholder="مثال: تعميم بشأن أسبوع التطوع" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">تاريخ الإصدار (هجري) *</label>
          <input data-testid="circular-date-input" value={form.issue_date} onChange={(e) => setForm({ ...form, issue_date: e.target.value })}
            className={inputCls} placeholder="مثال: 24/03/1448" dir="ltr" />
        </div>
      </div>
      <div className="flex items-end gap-3 flex-wrap">
        <div className="flex-1 min-w-[220px]">
          <label className="text-xs font-bold text-mutext block mb-1.5">ملف التعميم (PDF أو صورة JPG/PNG)</label>
          <input ref={fileRef} data-testid="circular-file-input" type="file" accept=".pdf,image/jpeg,image/png" className={inputCls} />
        </div>
        <button data-testid="circular-add-btn" onClick={onAdd} disabled={busy} className={btnPrimary}>
          <Plus className="w-4 h-4" /> {busy ? "جارٍ الإضافة …" : "إضافة التعميم"}
        </button>
      </div>
    </div>
  );
}
